import React from 'react'
import OrdersTableHeader from './OrdersTableHeader'
import OrderRow from './OrderRow'
import { Table } from 'semantic-ui-react'
import SplitClient from "../../utils/splitClient";
import * as sessionHelpers from "../../helpers/sessionHelpers";

export default class OrdersTable extends React.Component {
    state = {
        version: ''
    }

    async componentDidMount() {
        const treatment = await SplitClient.getTreatment("SHOP_ORDERS",{ email: sessionHelpers.getApplicationCookie('current_user_email') })
        this.setState({version: treatment.SHOP_ORDERS})
    }

    render() {
        const { orders, adminUser, updateOrder, checklistItems, sortableHeaderCell } = this.props

        return (
            <React.Fragment>
                <Table.Header>
                    <OrdersTableHeader
                        checklistItems={checklistItems}
                        sortableHeaderCell={sortableHeaderCell}
                    />
                </Table.Header>
                <Table.Body>
                    {orders.map((order, i) => {
                        const { originator, vehicle, shop, order_services } = order

                        return (
                            <OrderRow
                                key={`order-row-${i + 2}`}
                                order={order}
                                originator={originator}
                                vehicle={vehicle}
                                shop={shop}
                                orderServices={order_services}
                                adminUser={adminUser}
                                updateOrder={updateOrder}
                                checklistItems={checklistItems}
                                isLastRow={i === orders.length - 1}
                                version={this.state.version}
                            />
                        )
                    })}
                </Table.Body>
            </React.Fragment>
        )
    }
} // OrdersTable
